const routes = [
  {
    path: '/otc',
    name: 'otc',
    component: () => import('@/views/otc/index.vue'),
    meta: {
      auth: false,
      title: '入金挖矿',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/otc-record',
    name: 'otc-record',
    component: () => import('@/views/otc/details.vue'),
    meta: {
      auth: false,
      title: '入金记录',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('@/views/wallet/index.vue'),
    meta: {
      auth: false,
      title: '钱包',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/wallet-details',
    name: 'wallet-details',
    component: () => import('@/views/wallet/details.vue'),
    meta: {
      auth: false,
      title: '钱包详情',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/wallet-exchange',
    name: 'wallet-exchange',
    component: () => import('@/views/wallet/exchange.vue'),
    meta: {
      auth: false,
      title: '兑换',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/wallet-transfer',
    name: 'wallet-transfer',
    component: () => import('@/views/wallet/transfer.vue'),
    meta: {
      auth: false,
      title: '转账',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/wallet-ticket',
    name: 'wallet-ticket',
    component: () => import('@/views/wallet/ticket.vue'),
    meta: {
      auth: false,
      title: '门票兑换',
      keepAlive: true,
      headerTheme: 'dark'
    }
  },
  {
    path: '/wallet-record',
    name: 'wallet-record',
    component: () => import('@/views/wallet/component/record.vue'),
    meta: {
      auth: false,
      title: '资产记录',
      keepAlive: true,
      headerTheme: 'dark'
    }
  }
]
export default routes
